<template>
  <div class="search_bar">
    <div class="vehicle_types">
      <a
        :class="type[1] == selected_type ? 'selected_type' : ''"
        v-for="type in vehicle_types"
        :key="type[0]"
        @click="getMakesByType(type[1])"
      >
        <img src="../assets/icons/car.svg" class="icon" v-if="type[2] == 1" />
        <img src="../assets/icons/bike.svg" class="icon" v-if="type[2] == 2" />
        <img src="../assets/icons/boat.svg" class="icon" v-if="type[2] == 3" />
        {{ type[0] }}</a
      >
    </div>
    <h3>Znajdź swój wymarzony <span>samochód</span></h3>
    <div class="car_type">
      <div class="select_box">
        <multiselect
          v-model="selected.car_brand"
          :options="car_brands"
          class="dropdown"
          :searchable="true"
          :show-labels="false"
          placeholder="Marka"
          track-by="name"
          label="name"
          @update:modelValue="getModelsByMake(selected.car_brand.id)"
        ></multiselect>
      </div>
      <div class="select_box">
        <multiselect
          v-model="selected.car_model"
          :options="car_models"
          class="dropdown"
          :searchable="true"
          :show-labels="false"
          placeholder="Model"
        ></multiselect>
      </div>
    </div>
    <div class="year">
      <div class="select_box">
        <!-- <label id="label_year_from">ROCZNIK OD</label> -->
        <multiselect
          class="dropdown"
          v-model="selected.year_from"
          :options="
            Array.from(
              { length: 2024 - 2000 + 1 },
              (_, index) => 2000 + index
            ).reverse()
          "
          value="2020"
          :searchable="true"
          :show-labels="false"
          placeholder="Rocznik od"
        ></multiselect>
      </div>
      <div class="select_box">
        <!-- <label>ROCZNIK DO</label> -->
        <multiselect
          class="dropdown"
          v-model="selected.year_to"
          :options="
            Array.from(
              { length: 2024 - 2000 + 1 },
              (_, index) => 2000 + index
            ).reverse()
          "
          :searchable="true"
          :show-labels="false"
          placeholder="Rocznik do"
        ></multiselect>
      </div>
    </div>
    <div class="select_auction">
      <!-- <div class="group">
        <input
          type="radio"
          name="IAAI"
          v-model="selected.auction_name"
          value="iaai"
        />

        <label for="IAAI">IAAI</label>
      </div>
      <div class="group">
        <input
          type="radio"
          name="COPART"
          v-model="selected.auction_name"
          value="copart"
        />

        <label for="COPART">COPART</label>
      </div>
      <div class="group">
        <input
          type="radio"
          name="all"
          v-model="selected.auction_name"
          value=""
        />

        <label for="all">WSZYSTKIE</label>
      </div> -->
      <div class="group">
        <div>
          <label class="toggle iaai">
            <input
              type="checkbox"
              @change="
                () => {
                  if (selected.auction_name == null) {
                    selected.auction_name = 'copart';
                  } else if (selected.auction_name == 'copart') {
                    selected.auction_name = null;
                  } else if (selected.auction_name == 'iaai') {
                    selected.auction_name = 'copart';
                  }
                }
              "
              :checked="
                selected.auction_name == 'iaai' || selected.auction_name == null
              "
            />
            <span class="slider"></span>
          </label>
          <span class="auction_name">IAAI</span>
        </div>
        <div>
          <label class="toggle">
            <input
              type="checkbox"
              @change="
                () => {
                  if (selected.auction_name == null) {
                    selected.auction_name = 'iaai';
                  } else if (selected.auction_name == 'iaai') {
                    selected.auction_name = null;
                  } else if (selected.auction_name == 'copart') {
                    selected.auction_name = 'iaai';
                  }
                }
              "
              :checked="
                selected.auction_name == 'copart' ||
                selected.auction_name == null
              "
            />
            <span class="slider"></span>
          </label>
          <span class="auction_name">COPART</span>
        </div>
      </div>
    </div>
    <p>lub szukaj po numerze VIN</p>
    <div class="vin_search">
      <input type="text" placeholder="Numer VIN lub LOT" v-model="vin_number" />
    </div>
    <div class="search_btn">
      <button name="search_button" class="search_button" @click="search">
        SZUKAJ
      </button>
    </div>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<script>
import Multiselect from "vue-multiselect";
import axios from "axios";
export default {
  name: "SearchBar",
  components: {
    Multiselect,
  },
  data() {
    return {
      selected: {
        car_brand: null,
        car_model: null,
        year_from: null,
        year_to: null,
        auction_name: null,
      },
      car_brands: [],
      car_models: [],
      vin_number: null,
      vehicle_types: [
        ["SAMOCHÓD", "", 1],
        ["MOTOCYKL", "MOTORCYCLE", 2],
        // ["ŁÓDZ", "BOAT", 3],
      ],
      selected_type: "",
    };
  },
  beforeMount() {
    this.getDictionarys();
  },
  methods: {
    search() {
      if (this.selected.car_brand != null) {
        this.selected.car_brand = this.selected.car_brand["name"];
      }
      const url = new URL("https://amerykacars.pl/wyniki-wyszukiwania/");
      if (this.vin_number != null) {
        if (this.vin_number.toString().length == 17) {
          window.top.location.href = `https://amerykacars.pl/wyniki-wyszukiwania/?vin_number=${this.vin_number}`;
        } else {
          window.top.location.href = `https://amerykacars.pl/wyniki-wyszukiwania/?lot_number=${this.vin_number}`;
        }
      } else {
        if (this.selected.car_brand != null) {
          url.searchParams.append("car_brand", this.selected.car_brand);
        }
        if (this.selected.auction_name != null) {
          url.searchParams.append("auction_name", this.selected.auction_name);
        }
        if (this.selected.car_model != null) {
          url.searchParams.append("car_model", this.selected.car_model);
        }
        if (this.selected.year_from != null) {
          url.searchParams.append("year_from", this.selected.year_from);
        }
        if (this.selected.year_to != null) {
          url.searchParams.append("year_to", this.selected.year_to);
        }
        if (this.selected_type != null) {
          url.searchParams.append("vehicle_type", this.selected_type);
        }
        window.top.location.href = url;
      }
    },
    async getDictionarys() {
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-makes",
        {},
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log(data);
      var makes = [];
      for (var i in data) {
        if (data[i]["make"] != "") {
          makes.push({
            name: data[i]["make"],
            id: data[i]["id"],
          });
        }
      }
      this.car_brands = makes;

      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-models",
        {},
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log(data);
      var models = [];
      for (var i in data["result"]) {
        if (data["result"][i]["model"] != "") {
          models.push(data["result"][i]["model"]);
        }
      }
      this.car_models = models;
    },
    async getMakesByType(type) {
      this.selected_type = type;
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-makes-by-type",
        {
          vehicle_type: type,
        },
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log(data);
      var makes = [];
      for (var i in data) {
        makes.push({
          name: data[i]["make"],
          id: data[i]["id"],
        });
      }
      this.car_brands = makes;
    },
    async getModelsByMake(make_id) {
      console.log(make_id);
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-model-by-make",
        {
          makeId: make_id,
        },
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log(data);
      var models = [];
      for (var i in data) {
        if (data[i]["model"] != "") {
          models.push(data[i]["model"]);
        }
      }
      this.car_models = models;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.multiselect__option--highlight {
  background-color: #011f68;

  outline: none;
  color: white;
}
.multiselect__option:hover {
  background-color: #011f68 !important;
}
.multiselect__content-wrapper::-webkit-scrollbar {
  display: none;
}

.multiselect__placeholder {
  color: #011f68 !important;
}

/* Hide scrollbar for IE, Edge and Firefox */
.multiselect__content-wrapper {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search_bar {
  width: 100%;
  background: rgba(1, 31, 104, 0.75);
  padding-bottom: 20px;
  text-align: center;
  max-width: 600px;
}

.vehicle_types {
  display: flex;
}

.vehicle_types a:hover {
  background: rgba(255, 255, 255, 0.1);
  opacity: 1;
}

.vehicle_types .selected_type {
  border-bottom: 2px solid #00a8fc;
  background-color: transparent;
}
.vehicle_types a {
  color: #fff;
  background-color: transparent;
  opacity: 0.6;
  font-family: "bicyclette";
  font-size: 14px;
  font-weight: 700;
  line-height: 1.8;
  text-decoration: none;
  padding: 14px 25px;
  flex-direction: column;
  display: flex;
  align-items: center;
  gap: 4px;
}
.vehicle_types a.selected_type svg path,
.vehicle_types a:hover svg path {
  stroke: #fff;
}

.select_auction {
  display: flex;
  font-size: 18px;
  color: white;
  justify-content: flex-start;
  width: 100%;
  margin: 3px 0 0 0;
  padding: 0 30px;
  gap: 8px 15px;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.group {
  display: flex;
  gap: 20px;
  align-items: center;
}
.group div {
  display: flex;
  gap: 4px;
}
.icon {
  fill: white;
}

.car_type {
  display: flex;
  flex-direction: column;
}

.car_type .select_box {
  padding: 10px 30px;
}

.car_type .select_box .dropdown {
  width: 100% !important;
}

.year {
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr;
  gap: 16px 16px;
  padding: 0px 30px;
}
.year .select_box {
  padding: 10px 0px;
}

.year .select_box .dropdown {
  width: 100% !important;
}

p {
  font-family: "bicyclette";
  font-size: 15px;
  font-weight: 500;
  line-height: 19px;
  color: #fff;
  display: block;
  margin: 0;
  padding: 10px 0 15px;
}
/*  */

h3 {
  font-family: "bicyclette";
  font-size: 30px;
  font-weight: 500;
  line-height: 39px;
  text-align: left;
  margin: 27px 30px 20px;
  color: #fff;
}

h3 span {
  color: #00a8fc;
}
/*  */

.multiselect__tags,
input {
  border: none;
  border-radius: 4px;
  width: 95%;
  height: 43px;
  padding: 1px 8px;
}
.vin_search {
  padding: 10px 30px;
}
input::-ms-input-placeholder,
input::placeholder {
  font-family: "bicyclette";
  font-size: 15px;
  font-weight: 500;
  line-height: 19px;
  text-align: left;
  color: #011f68;
}

.search_button {
  border-radius: 6px;
  border: none;
  width: 100%;
  background: #be1e2d;
  font-family: "bicyclette";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  height: 43px;
  color: #fff;
  transition: all 0.2s ease-in-out;
}
.search_btn {
  padding: 10px 30px;
}
.block-button {
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  background-color: #edf2f7;
  color: #011f68;
  font-weight: bold;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 7px;
  margin-bottom: 7px;
}
.block-button.active {
  color: white;
  background-color: #011f68;
}
.search_button:hover {
  background: #fff;
  color: #be1e2d;
  cursor: pointer;
}

@media (max-width: 576px) {
  .search_bar h3 {
    font-size: 28px;
    line-height: 36px;
  }
}

@media (max-width: 420px) {
  .search_bar .year {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
.toggle {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 20px;
}

.toggle input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #333;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #be1e2d;
}

input:checked + .slider:before {
  transform: translateX(11px);
}
</style>